import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaMoon, FaSun, FaUserPlus, FaCar, FaCalendarPlus, FaMoneyBillWave } from 'react-icons/fa';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import { useSettings } from '../../context/SettingsContext';
import { getUploadUrl } from '../../utils/apiBase';

const PAGE_TITLES = {
  '/dashboard':    'Tableau de bord',
  '/voitures':     'Véhicules',
  '/clients':      'Clients',
  '/entretiens':   'Entretiens',
  '/contracts':    'Contrats',
  '/reservations': 'Réservations',
  '/planning':     'Planning',
  '/reports':      'Rapports',
  '/profile':      'Profil',
  '/settings':     'Paramètres',
  '/users':        'Utilisateurs',
  '/accounts':     'Comptes',
  '/feedback':     'Avis clients',
  '/support':      'Support',
};

const MobileHeader = ({ onMenuToggle }) => {
  const { currentUser: authUser } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const { companyInfo } = useSettings();
  const location = useLocation();

  if (location.pathname === '/login' || !authUser) return null;

  const getPageTitle = () => {
    const path = location.pathname;
    for (const [route, title] of Object.entries(PAGE_TITLES)) {
      if (path.startsWith(route)) return title;
    }
    return companyInfo?.name || authUser?.Account?.name || 'Rentora';
  };

  return (
    <header className="mob-hdr" dir="ltr">
      <button className="mob-hdr__btn" onClick={onMenuToggle} aria-label="Menu">
        <FaBars />
      </button>

      <div className="mob-hdr__center">
        {companyInfo?.logo_path && (
          <img
            src={getUploadUrl(companyInfo.logo_path)}
            alt=""
            className="mob-hdr__logo"
            onError={e => { e.target.style.display = 'none'; }}
          />
        )}
        <span className="mob-hdr__title">{getPageTitle()}</span>
      </div>

      <div className="mob-hdr__actions">
        <Link to="/ajouter-client"              className="mob-hdr__action" aria-label="Ajouter client"><FaUserPlus /></Link>
        <Link to="/formulaire-voiture"          className="mob-hdr__action" aria-label="Ajouter voiture"><FaCar /></Link>
        <Link to="/reservations"                className="mob-hdr__action" aria-label="Ajouter réservation"><FaCalendarPlus /></Link>
        <Link to="/entretiens?action=addExpense" className="mob-hdr__action" aria-label="Ajouter dépense"><FaMoneyBillWave /></Link>
        <button className="mob-hdr__btn" onClick={toggleTheme} aria-label={theme === 'light' ? 'Mode sombre' : 'Mode clair'}>
          {theme === 'light' ? <FaMoon /> : <FaSun />}
        </button>
      </div>
    </header>
  );
};

export default MobileHeader;
